import { EnumColor } from '@40seas/frontend/common/providers';
import { AiprizeCompanyDecision } from '@40seas/entities/aiprize';

export const AiprizeCompanyDecisionColorMapping = {
    [AiprizeCompanyDecision.Unknown]: 'default',
    [AiprizeCompanyDecision.Approved]: 'success',
    [AiprizeCompanyDecision.Review]: 'info',
    [AiprizeCompanyDecision.Declined]: 'error',
} as { [key in AiprizeCompanyDecision]: EnumColor };
